import { render } from "./ApiRunsTable.vue?vue&type=template&id=2950bfbf&scoped=true&ts=true"
import script from "./ApiRunsTable.vue?vue&type=script&lang=ts"
export * from "./ApiRunsTable.vue?vue&type=script&lang=ts"

import "./ApiRunsTable.vue?vue&type=style&index=0&id=2950bfbf&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2950bfbf"]])

export default __exports__